import { ASSISTANT_MESSAGE_STATUS } from '../../rest/converse';
import type { ChatMessage, AssistantMessage } from '../../store/converse/types';

export const isAssistantMessageNotIdle = (message: ChatMessage): message is AssistantMessage => {
    return message?.userType === 'assistant' && message.messageMetadata?.status !== ASSISTANT_MESSAGE_STATUS.IDLE;
};
